import { IPlainCardProps, IStackItemStyles, getTheme } from '@fluentui/react';
import AppContext from 'App/AppContext';
import { IPText } from 'baseComponents';
import { IPHoverCard, IPHoverCardType } from 'baseComponents/HoverCard/IPHoverCard';
import { IPStack } from 'baseComponents/Stack/IPStack';
import KanbanCardTaskGenericWithState from 'components/Kanban/Cards/KanbanCardTaskGenericWithState';
import { globalTextStylesBold } from 'globalStyles';
import Task from 'models/tasks/task';
import { useContext } from 'react';

interface ITaskDateLinkWithHoverCardProps {
  tasks: Task[];
  onTaskClick: (task: Task) => void;
}

export const TaskOverflowLinkWithHoverCard = (props: ITaskDateLinkWithHoverCardProps) => {
  const appContext = useContext(AppContext);
  const theme = getTheme();

  const onRenderCompactCardMultiple = (items: Task[]): JSX.Element => {
    return (
      <IPStack horizontal wrap styles={{ root: { maxWidth: '50vw', maxHeight: '50vh', overflow: 'auto' } }}>
        {items.map((item) => {
          return (
            <IPStack.Item
              key={'KanbanCardTaskForControlAssignee' + item.taskId.toString()}
              styles={{ root: { width: 210, borderRadius: '5px', margin: 3 } }}
            >
              <KanbanCardTaskGenericWithState
                key={item.taskId.toString()}
                task={item}
                onClick={() => props.onTaskClick(item)}
              />
            </IPStack.Item>
          );
        })}
      </IPStack>
    );
  };

  const plainCardProps: IPlainCardProps = {
    onRenderPlainCard: onRenderCompactCardMultiple,
    renderData: props.tasks,
  };

  const getLinkStyleProps = (): IStackItemStyles => {
    const backgroundColor = appContext.useDarkMode ? theme.palette.themeDarkAlt : theme.palette.themeLighterAlt;

    return {
      root: {
        background: backgroundColor,
        color: appContext.useDarkMode ? theme.palette.themeLight : theme.palette.themeSecondary,
        height: 22,
        width: 30,
        borderRadius: 4,
        borderColor: theme.palette.themeSecondary,
        cursor: 'pointer',
      },
    };
  };

  //
  // Main render
  //
  return (
    <IPHoverCard
      cardOpenDelay={300}
      type={IPHoverCardType.plain}
      plainCardProps={plainCardProps}
      instantOpenOnClick={false}
    >
      <IPStack.Item styles={getLinkStyleProps()}>
        <IPStack horizontalAlign="center" verticalAlign="center">
          <IPText variant="mediumPlus" styles={globalTextStylesBold}>
            {`+${props.tasks.length}`}
          </IPText>
        </IPStack>
      </IPStack.Item>
    </IPHoverCard>
  );
};
